@if (form) {
  <form autocomplete="off"
    [formGroup]="form"
    >
    <div class="form-container"
      fxLayout="row"
      fxLayoutAlign="center">
      <div fxFlex.gt-sm="480px">
        <h2> Edit Biographic Fields</h2>
        <mat-form-field>
          <mat-label>First Name</mat-label>
          <input type="text"
            id="firstName"
            name="firstName"
            matInput
            formControlName="firstName"
            required>
            <mat-error>This field is required.</mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Last Name</mat-label>
            <input type="text"
              id="lastName"
              name="lastName"
              matInput
              formControlName="lastName"
              required>
              <mat-error>This field is required.</mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Gender</mat-label>
              <mat-select id="gender"
                formControlName="gender"
                disableOptionCentering="true"
                required>
                @for (formValue of pending.genderValidValues; track $index) {
                  <mat-option [value]="formValue">{{getGenderDisplayName(formValue)}}</mat-option>
                }
              </mat-select>
              <mat-error>This field is required.</mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Student ID Number</mat-label>
              <input type="text"
                id="stateStudentId"
                name="stateStudentId"
                matInput
                formControlName="stateStudentId"
                required>
                <mat-error>This field is required.</mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Date of Birth</mat-label>
                <input id="birthDate"
                  name="birthDate"
                  matInput
                  autocomplete="off"
                  [matDatepicker]="birthPicker"
                  formControlName="birthDate"
                  placeholder="Choose a date"
                  required>
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="birthPicker">
                    <mat-icon matDatepickerToggleIcon>date_range</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker [calendarHeaderComponent]="ecaCalendarHeader"
                  #birthPicker></mat-datepicker>
                  <mat-error>A valid birth date is required.</mat-error>
                </mat-form-field>

                @if (isExtensionRequired('Ethnicity_HispanicLatino_Paper')) {
                  <mat-form-field>
                    <mat-label>Ethnicity</mat-label>
                    <mat-select id="Ethnicity_HispanicLatino_Paper"
                                formControlName="Ethnicity_HispanicLatino_Paper"
                                disableOptionCentering="true"
                                required="true">
                      @for (formSelectOption of getFormSelectOptionsForField('Ethnicity_HispanicLatino_Paper'); track $index) {
                        <mat-option [value]="formSelectOption.value">{{formSelectOption.label}}</mat-option>
                      }
                    </mat-select>
                    <mat-error>This field is required.</mat-error>
                  </mat-form-field>
                }

                @if (isDemographicGroupRequired('race')) {
                  <mat-form-field>
                    <mat-label>Race</mat-label>
                    <eca-multi-select
                      formControlName="races"
                      required="true"
                      [options]="getFormSelectOptionsForField('Race')"
                    >
                    </eca-multi-select>
                    <mat-error>This field is required.</mat-error>
                  </mat-form-field>
                }

                @if (isDemographicGroupRequired('program')) {
                  <mat-form-field>
                    <mat-label>Program</mat-label>
                    <eca-multi-select
                      formControlName="programs"
                      required="true"
                      [options]="getFormSelectOptionsForField('Program')"
                    >
                    </eca-multi-select>
                    <mat-error>This field is required.</mat-error>
                  </mat-form-field>
                }

                @if (isExtensionRequired('Highest_Level_Education_Paper')) {
                  <mat-form-field>
                    <mat-label>Highest Level of Education</mat-label>
                    <mat-select id="Highest_Level_Education_Paper"
                                formControlName="Highest_Level_Education_Paper"
                                disableOptionCentering="true"
                                required="true">
                      @for (formSelectOption of getFormSelectOptionsForField('Highest_Level_Education_Paper'); track $index) {
                        <mat-option [value]="formSelectOption.value">{{formSelectOption.label}}</mat-option>
                      }
                    </mat-select>
                    <mat-error>This field is required.</mat-error>
                  </mat-form-field>
                }

                @if (isExtensionRequired('Employment_Status_Paper')) {
                  <mat-form-field>
                    <mat-label>Labor Force Status</mat-label>
                    <mat-select id="Employment_Status_Paper"
                                formControlName="Employment_Status_Paper"
                                disableOptionCentering="true"
                                required="true">
                      @for (formSelectOption of getFormSelectOptionsForField('Employment_Status_Paper'); track $index) {
                        <mat-option [value]="formSelectOption.value">{{formSelectOption.label}}</mat-option>
                      }
                    </mat-select>
                    <mat-error>This field is required.</mat-error>
                  </mat-form-field>
                }

                @if (isExtensionRequired('PublicAssistance_Paper')) {
                  <mat-form-field>
                    <mat-label>Public Assistance Status</mat-label>
                    <mat-select id="PublicAssistance_Paper"
                                formControlName="PublicAssistance_Paper"
                                disableOptionCentering="true"
                                required="true">
                      @for (formSelectOption of getFormSelectOptionsForField('PublicAssistance_Paper'); track $index) {
                        <mat-option [value]="formSelectOption.value">{{formSelectOption.label}}</mat-option>
                      }
                    </mat-select>
                    <mat-error>This field is required.</mat-error>
                  </mat-form-field>
                }

                <!-- RD Group -->
                @if (hasTstTestDate()) {
                  <mat-form-field>
                    <mat-label>Date of Testing</mat-label>
                    <input id="tstTestDate"
                      name="tstTestDate"
                      matInput
                      autocomplete="off"
                      [matDatepicker]="tstPicker"
                      formControlName="tstTestDate"
                      placeholder="Choose a date"
                      [required]="isAnyTestPartAttempted()">
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="tstPicker">
                        <mat-icon matDatepickerToggleIcon>date_range</mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker [calendarHeaderComponent]="ecaCalendarHeader"
                      #tstPicker></mat-datepicker>
                      <mat-error>A valid date is required.</mat-error>
                    </mat-form-field>
                  }
                  @if (hasFormSpecifier('tst')) {
                    <div>
                      <mat-form-field>
                        <mat-label>Test Form Specifier</mat-label>
                        <mat-select id="tstFormSpecifier"
                          formControlName="tstFormSpecifier"
                          disableOptionCentering="true"
                          [required]="true">
                          @for (formValue of pending.formSpecifierValidValues; track formValue) {
                            <mat-option [value]="formValue">{{formValue}}</mat-option>
                          }
                        </mat-select>
                        <mat-error>This field is required.</mat-error>
                      </mat-form-field>
                    </div>
                  }
                  @if (hasLevelSpecifier('tst')) {
                    <div>
                      <mat-form-field>
                        <mat-label>Test Level Specifier</mat-label>
                        <mat-select id="tstLevelSpecifier"
                          formControlName="tstLevelSpecifier"
                          disableOptionCentering="true"
                          [required]="true">
                          @for (formValue of pending.levelSpecifierValidValues; track formValue) {
                            <mat-option [value]="formValue">{{formValue}}</mat-option>
                          }
                        </mat-select>
                        <mat-error>This field is required.</mat-error>
                      </mat-form-field>
                    </div>
                  }
                  @if (isTestPartDateOnForm('READING')) {
                    <mat-form-field>
                      <mat-label>Reading Date of Testing</mat-label>
                      <input id="readingTestDate"
                        name="readingTestDate"
                        matInput
                        autocomplete="off"
                        [matDatepicker]="readPicker"
                        formControlName="readingTestDate"
                        placeholder="Choose a date"
                        [required]="isTestPartAttempted('READING')">
                        <mat-datepicker-toggle
                          matSuffix
                          [for]="readPicker">
                          <mat-icon matDatepickerToggleIcon>date_range</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker [calendarHeaderComponent]="ecaCalendarHeader"
                        #readPicker></mat-datepicker>
                        <mat-error>A valid date is required.</mat-error>
                      </mat-form-field>
                    }
                    @if (hasFormSpecifier('rd')) {
                      <div>
                        <mat-form-field>
                          <mat-label>Reading Form Specifier</mat-label>
                          <mat-select id="rdFormSpecifier"
                            formControlName="rdFormSpecifier"
                            disableOptionCentering="true"
                            [required]="isTestPartAttempted('READING')">
                            @for (formValue of pending.formSpecifierValidValues; track formValue) {
                              <mat-option [value]="formValue">{{formValue}}</mat-option>
                            }
                          </mat-select>
                          <mat-error>This field is required.</mat-error>
                        </mat-form-field>
                      </div>
                    }
                    @if (hasLevelSpecifier('rd')) {
                      <div>
                        <mat-form-field>
                          <mat-label>Reading Level Specifier</mat-label>
                          <mat-select id="rdLevelSpecifier"
                            formControlName="rdLevelSpecifier"
                            disableOptionCentering="true"
                            [required]="isTestPartAttempted('READING')">
                            @for (levelValue of pending.levelSpecifierValidValues; track levelValue) {
                              <mat-option [value]="levelValue">{{levelValue}}</mat-option>
                            }
                          </mat-select>
                          <mat-error>This field is required.</mat-error>
                        </mat-form-field>
                      </div>
                    }
                    @if (isTestPartDateOnForm('MATH')) {
                      <mat-form-field>
                        <mat-label>Mathematics Date of Testing</mat-label>
                        <input id="mathTestDate"
                          name="mathTestDate"
                          matInput
                          autocomplete="off"
                          [matDatepicker]="mathPicker"
                          formControlName="mathTestDate"
                          placeholder="Choose a date"
                          [required]="isTestPartAttempted('MATH')">
                          <mat-datepicker-toggle
                            matSuffix
                            [for]="mathPicker">
                            <mat-icon matDatepickerToggleIcon>date_range</mat-icon>
                          </mat-datepicker-toggle>
                          <mat-datepicker [calendarHeaderComponent]="ecaCalendarHeader"
                          #mathPicker></mat-datepicker>
                          <mat-error>A valid date is required.</mat-error>
                        </mat-form-field>
                      }
                      @if (hasFormSpecifier('md')) {
                        <div>
                          <mat-form-field>
                            <mat-label>Math Form Specifier</mat-label>
                            <mat-select id="mdFormSpecifier"
                              formControlName="mdFormSpecifier"
                              disableOptionCentering="true"
                              [required]="isTestPartAttempted('MATH')">
                              @for (formValue of pending.formSpecifierValidValues; track formValue) {
                                <mat-option [value]="formValue">{{formValue}}</mat-option>
                              }
                            </mat-select>
                            <mat-error>This field is required.</mat-error>
                          </mat-form-field>
                        </div>
                      }
                      @if (hasLevelSpecifier('md')) {
                        <div>
                          <mat-form-field>
                            <mat-label>Math Level Specifier</mat-label>
                            <mat-select id="mdLevelSpecifier"
                              formControlName="mdLevelSpecifier"
                              disableOptionCentering="true"
                              [required]="isTestPartAttempted('MATH')">
                              @for (levelValue of pending.levelSpecifierValidValues; track levelValue) {
                                <mat-option [value]="levelValue">{{levelValue}}</mat-option>
                              }
                            </mat-select>
                            <mat-error>This field is required.</mat-error>
                          </mat-form-field>
                        </div>
                      }
                      @if (isTestPartDateOnForm('SPEAKING')) {
                        <mat-form-field>
                          <mat-label>Speaking Date of Testing</mat-label>
                          <input id="speakingTestDate"
                            name="speakingTestDate"
                            matInput
                            autocomplete="off"
                            [matDatepicker]="speakingPicker"
                            formControlName="speakingTestDate"
                            placeholder="Choose a date"
                            [required]="isTestPartAttempted('SPEAKING')">
                            <mat-datepicker-toggle
                              matSuffix
                              [for]="speakingPicker">
                              <mat-icon matDatepickerToggleIcon>date_range</mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker [calendarHeaderComponent]="ecaCalendarHeader"
                            #speakingPicker></mat-datepicker>
                            <mat-error>A valid date is required.</mat-error>
                          </mat-form-field>
                        }
                        @if (hasFormSpecifier('sp')) {
                          <div>
                            <mat-form-field>
                              <mat-label>Speaking Form Specifier</mat-label>
                              <mat-select id="spFormSpecifier"
                                formControlName="spFormSpecifier"
                                disableOptionCentering="true"
                                [required]="isTestPartAttempted('SPEAKING')">
                                @for (formValue of pending.formSpecifierValidValues; track formValue) {
                                  <mat-option [value]="formValue">{{formValue}}</mat-option>
                                }
                              </mat-select>
                              <mat-error>This field is required.</mat-error>
                            </mat-form-field>
                          </div>
                        }
                        @if (hasLevelSpecifier('sp')) {
                          <div>
                            <mat-form-field>
                              <mat-label>Speaking Level Specifier</mat-label>
                              <mat-select id="spLevelSpecifier"
                                formControlName="spLevelSpecifier"
                                disableOptionCentering="true"
                                [required]="isTestPartAttempted('SPEAKING')">
                                @for (levelValue of pending.levelSpecifierValidValues; track levelValue) {
                                  <mat-option [value]="levelValue">{{levelValue}}</mat-option>
                                }
                              </mat-select>
                              <mat-error>This field is required.</mat-error>
                            </mat-form-field>
                          </div>
                        }
                        @if (isTestPartDateOnForm('WRITING')) {
                          <mat-form-field>
                            <mat-label>Writing Date of Testing</mat-label>
                            <input id="writingTestDate"
                              name="writingTestDate"
                              matInput
                              autocomplete="off"
                              [matDatepicker]="writingPicker"
                              formControlName="writingTestDate"
                              placeholder="Choose a date"
                              [required]="isTestPartAttempted('WRITING')">
                              <mat-datepicker-toggle
                                matSuffix
                                [for]="writingPicker">
                                <mat-icon matDatepickerToggleIcon>date_range</mat-icon>
                              </mat-datepicker-toggle>
                              <mat-datepicker [calendarHeaderComponent]="ecaCalendarHeader"
                              #writingPicker></mat-datepicker>
                              <mat-error>A valid date is required.</mat-error>
                            </mat-form-field>
                          }
                          @if (hasFormSpecifier('wr')) {
                            <div>
                              <mat-form-field>
                                <mat-label>Writing Form Specifier</mat-label>
                                <mat-select id="wrFormSpecifier"
                                  formControlName="wrFormSpecifier"
                                  disableOptionCentering="true"
                                  [required]="isTestPartAttempted('WRITING')">
                                  @for (formValue of pending.formSpecifierValidValues; track formValue) {
                                    <mat-option [value]="formValue">{{formValue}}</mat-option>
                                  }
                                </mat-select>
                                <mat-error>This field is required.</mat-error>
                              </mat-form-field>
                            </div>
                          }
                          @if (hasLevelSpecifier('wr')) {
                            <div>
                              <mat-form-field>
                                <mat-label>Writing Level Specifier</mat-label>
                                <mat-select id="wrLevelSpecifier"
                                  formControlName="wrLevelSpecifier"
                                  disableOptionCentering="true"
                                  [required]="isTestPartAttempted('WRITING')">
                                  @for (levelValue of pending.levelSpecifierValidValues; track levelValue) {
                                    <mat-option [value]="levelValue">{{levelValue}}</mat-option>
                                  }
                                </mat-select>
                                <mat-error>This field is required.</mat-error>
                              </mat-form-field>
                            </div>
                          }
                          @if (isTestPartDateOnForm('LISTENING')) {
                            <mat-form-field>
                              <mat-label>Listening Date of Testing</mat-label>
                              <input id="listeningTestDate"
                                name="listeningTestDate"
                                matInput
                                autocomplete="off"
                                [matDatepicker]="listeningPicker"
                                formControlName="listeningTestDate"
                                placeholder="Choose a date"
                                [required]="isTestPartAttempted('LISTENING')">
                                <mat-datepicker-toggle
                                  matSuffix
                                  [for]="listeningPicker">
                                  <mat-icon matDatepickerToggleIcon>date_range</mat-icon>
                                </mat-datepicker-toggle>
                                <mat-datepicker [calendarHeaderComponent]="ecaCalendarHeader"
                                #listeningPicker></mat-datepicker>
                                <mat-error>A valid date is required.</mat-error>
                              </mat-form-field>
                            }
                            @if (hasFormSpecifier('li')) {
                              <div>
                                <mat-form-field>
                                  <mat-label>Listening Form Specifier</mat-label>
                                  <mat-select id="liFormSpecifier"
                                    formControlName="liFormSpecifier"
                                    disableOptionCentering="true"
                                    [required]="isTestPartAttempted('LISTENING')">
                                    @for (formValue of pending.formSpecifierValidValues; track formValue) {
                                      <mat-option [value]="formValue">{{formValue}}</mat-option>
                                    }
                                  </mat-select>
                                  <mat-error>This field is required.</mat-error>
                                </mat-form-field>
                              </div>
                            }
                            @if (hasLevelSpecifier('li')) {
                              <div>
                                <mat-form-field>
                                  <mat-label>Listening Level Specifier</mat-label>
                                  <mat-select id="liLevelSpecifier"
                                    formControlName="liLevelSpecifier"
                                    disableOptionCentering="true"
                                    [required]="isTestPartAttempted('LISTENING')">
                                    @for (levelValue of pending.levelSpecifierValidValues; track levelValue) {
                                      <mat-option [value]="levelValue">{{levelValue}}</mat-option>
                                    }
                                  </mat-select>
                                  <mat-error>This field is required.</mat-error>
                                </mat-form-field>
                              </div>
                            }
                            @if (isTestPartDateOnForm('LANGUAGE')) {
                              <mat-form-field>
                                <mat-label>Language Date of Testing</mat-label>
                                <input id="languageTestDate"
                                  name="languageTestDate"
                                  matInput
                                  autocomplete="off"
                                  [matDatepicker]="langPicker"
                                  formControlName="languageTestDate"
                                  placeholder="Choose a date"
                                  [required]="isTestPartAttempted('LANGUAGE')">
                                  <mat-datepicker-toggle
                                    matSuffix
                                    [for]="langPicker">
                                    <mat-icon matDatepickerToggleIcon>date_range</mat-icon>
                                  </mat-datepicker-toggle>
                                  <mat-datepicker [calendarHeaderComponent]="ecaCalendarHeader"
                                  #langPicker></mat-datepicker>
                                  <mat-error>A valid date is required.</mat-error>
                                </mat-form-field>
                              }
                              @if (hasFormSpecifier('la')) {
                                <div>
                                  <mat-form-field>
                                    <mat-label>Language Form Specifier</mat-label>
                                    <mat-select id="laFormSpecifier"
                                      formControlName="laFormSpecifier"
                                      disableOptionCentering="true"
                                      [required]="isTestPartAttempted('LANGUAGE')">
                                      @for (formValue of pending.formSpecifierValidValues; track formValue) {
                                        <mat-option [value]="formValue">{{formValue}}</mat-option>
                                      }
                                    </mat-select>
                                    <mat-error>This field is required.</mat-error>
                                  </mat-form-field>
                                </div>
                              }
                              @if (hasLevelSpecifier('la')) {
                                <div>
                                  <mat-form-field>
                                    <mat-label>Language Level Specifier</mat-label>
                                    <mat-select id="laLevelSpecifier"
                                      formControlName="laLevelSpecifier"
                                      disableOptionCentering="true"
                                      [required]="isTestPartAttempted('LANGUAGE')">
                                      @for (levelValue of pending.levelSpecifierValidValues; track levelValue) {
                                        <mat-option [value]="levelValue">{{levelValue}}</mat-option>
                                      }
                                    </mat-select>
                                    <mat-error>This field is required.</mat-error>
                                  </mat-form-field>
                                </div>
                              }
                              <div fxLayout="row"
                                fxLayoutAlign="end"
                                fxLayoutGap="10px">
                                <button mat-button
                                  type="button"
                                  [routerLink]="previousUrl"
                                  [disabled]="spinner$ | async">
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  mat-button
                                  color="primary"
                                  ecaThrottleClick
                                  (throttleClick)="onSubmit()"
                                  [disabled]="isSaveDisabled() || (spinner$ | async)">
                                  Save
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      }
